import React, { useState, useEffect } from   'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import { Row, Col, Card, CardBody } from 'react-bootstrap';
import { savePermisosPaginas } from '../Utils/indexedDBUtils';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import CargandoSpinner from '../Utils/CargandoSpinner';
registerLocale('es', es);
setDefaultLocale('es');

export default function AppDashboard() {
    const Navigate = useNavigate();
    const { token, fetchPermisosPaginas, nombre } = useAuth();
    const [ Cargando, setCargando] = useState(false);
    const [ mostrarDatosCaracterizacion, setMostrarDatosCaracterizacion] = useState(false);
    const [ mostrarDatosDdhh, setMostrarDatosDdhh] = useState(false);
    const [informeDashboard, setInformeDashboard] = useState({
        HogaresCaracterizacion: 0,
        PersonasCaracterizacion: 0,
        CabezaFamiliasxComuna: [{
            comuna: '',
            cuentahogaresxcomuna: 0
        }],
        Diagnosticos: 0,
        PersonasDiagnostico: 0,
        HogaresSsv: 0,
        PersonasSsv: 0,
    });
   
    useEffect(() => {
        const consultarPermisosPaginas = async () => {
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                await savePermisosPaginas(permisos); // Save the result to IndexedDB
            }
        };
        consultarPermisosPaginas();
        const fetchData = async () => {
            const url = '/caracterizacion/crearformularioinformedashboard';
            try {
                setCargando(true);
                const response = await apiService.get(url, token);
                const result = await response.data;
                setInformeDashboard(result)
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, [token, fetchPermisosPaginas]);
    function mostrarInformeDashboard(tablero) {
        if (tablero === 'caracterizacion') {
            setMostrarDatosCaracterizacion(true);
            setMostrarDatosDdhh(false);
        }
        if (tablero === 'ddhh') {
            setMostrarDatosDdhh(true);
            setMostrarDatosCaracterizacion(false);
        }
    }
    return (
        <div 
            className="content-wrapper"
            style={{
                backgroundImage: 'url("/dist/img/image1.jpeg")',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                minHeight: '100vh'
            }}
            >
            <section className="content-header">
                <div className="container-fluid">
                    <Card style={{
                        backgroundColor: 'rgba(23, 162, 184, 0.5)', // 50% transparency
                    }}>
                        <CardBody>
                            <h2 className="m-0">Hola, {nombre}</h2>
                            <h4>Te damos la bienvenida a la plataforma VIDAR</h4>
                            <p>Secretaria de Paz y DDHH</p>
                            <div
                                className="row mb-2"
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    marginTop: '16px',
                                    marginRight: '24px',
                                    zIndex: 400,
                                    justifyContent: 'flex-end',
                                    width: 'auto'
                                }}
                            >
                                <div className="col-sm-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() => mostrarInformeDashboard('caracterizacion')}
                                    >
                                        Datos EARV
                                    </button>
                                </div>
                                <div className="col-sm-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() => mostrarInformeDashboard('ddhh')}
                                    >
                                        Datos DDHH
                                    </button>
                                </div>
                                <div className="col-sm-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() => Navigate('/consulta/misindicadores')}
                                    >
                                        Mis Indicadores
                                    </button>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </section>
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {mostrarDatosCaracterizacion && (<Row 
                        id="dashboard-cards-row"
                        xs={1} 
                        sm={2} 
                        md={4} 
                        className="g-3"
                        style={{
                            position: 'fixed',
                            bottom: 0,
                            right: 0,
                            width: 'auto',
                            marginRight: '24px',
                            marginBottom: '60px',
                            zIndex: 1,
                            justifyContent: 'flex-end',
                            display: 'flex'
                        }}>
                        <Col key="caracterizacion-card">
                                <Card style={{
                                    backgroundColor: 'rgba(23, 162, 184, 0.5)', // 50% transparency
                                    color: 'white',
                                    minHeight: 220,
                                    height: '100%',
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }}>
                                <CardBody>
                                    <Row>
                                        <h5 style={{color:'black'}}>Total caracterizaci&oacute;n a partir del 2007</h5>
                                    </Row>
                                    <Row>
                                        <p><strong>{informeDashboard.HogaresCaracterizacion} Hogares</strong></p>
                                        <p><strong>{informeDashboard.PersonasCaracterizacion} Personas</strong></p>
                                    </Row>
                                    <button
                                        type="button"
                                        className="card-link btn btn-link p-0"
                                        onClick={() => window.location.href = "/dashboard"}
                                        tabIndex={0}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                window.location.href = "/dashboard";
                                            }
                                        }}
                                        aria-label="Más información"
                                    >
                                        Mas informaci&oacute;n <FaArrowAltCircleRight size={20} />
                                    </button>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col key="diagnosticos-card">
                            <Card style={{
                                backgroundColor: 'rgba(23, 162, 184, 0.5)', // 50% transparency
                                color: 'white',
                                minHeight: 220,
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}>
                                <CardBody>
                                    <Row>
                                        <h5 style={{color:'black'}}>Total DX a partir del 2019</h5>
                                    </Row>
                                    <Row>
                                        <p><strong>{informeDashboard.Diagnosticos} Diagnosticos</strong></p>
                                        <p><strong>{informeDashboard.PersonasDiagnostico} Personas</strong></p>
                                    </Row>
                                    <a href="/dashboard" className="card-link">Mas informaci&oacute;n <FaArrowAltCircleRight size={20} /></a>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col key="ssv-card">
                            <Card style={{
                                backgroundColor: 'rgba(23, 162, 184, 0.5)', // 50% transparency
                                color: 'white',
                                minHeight: 220,
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}>
                                <CardBody>
                                    <Row>
                                        <h5 style={{color:'black'}}>Total personas encuestadas SSV</h5>
                                    </Row>
                                    <Row>
                                        <p><strong>{informeDashboard.HogaresSsv} Familias</strong></p>
                                        <p><strong>{informeDashboard.PersonasSsv} Personas</strong></p>
                                    </Row>
                                    <a href="/dashboard" className="card-link">Mas informaci&oacute;n <FaArrowAltCircleRight size={20} /></a>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col key="albergues-card">
                            <Card style={{
                                backgroundColor: 'rgba(23, 162, 184, 0.5)', // 50% transparency
                                color: 'white',
                                minHeight: 220,
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}>
                                <CardBody>
                                    <Row>
                                        <h5 style={{color:'black'}}>Permanencia albergues</h5>
                                    </Row>
                                    <Row>
                                        <p><strong>{informeDashboard.FamiliasAlbergue} Familias</strong></p>
                                        <p><strong>{informeDashboard.PersonasAlbergue} Personas</strong></p>
                                    </Row>
                                    <a href="/dashboard" className="card-link">Mas informaci&oacute;n <FaArrowAltCircleRight size={20} /></a>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>)}
                    {mostrarDatosDdhh && (<Row 
                        id="dashboardDdhh-cards-row"
                        xs={1} 
                        sm={2} 
                        md={4} 
                        className="g-3"
                        style={{
                            position: 'fixed',
                            bottom: 0,
                            right: 0,
                            width: '60%',
                            marginRight: '24px',
                            marginBottom: '60px',
                            zIndex: 1,
                            justifyContent: 'flex-end',
                            display: 'flex'
                        }}>
                        <Col key="ddhh-card">
                                <Card style={{
                                    backgroundColor: 'rgba(23, 162, 184, 0.5)', // 50% transparency
                                    color: 'white',
                                    minHeight: 220,
                                    height: '100%',
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }}>
                                <CardBody>
                                    <Row>
                                        <h5 style={{color:'black'}}>Total atendidos Derechos Humanos</h5>
                                    </Row>
                                    <Row>
                                        <p><strong>{informeDashboard.HogaresDDHH} Hogares</strong></p>
                                        <p><strong>{informeDashboard.PersonasDDHH} Personas</strong></p>
                                    </Row>
                                    <button
                                        type="button"
                                        className="card-link btn btn-link p-0"
                                        onClick={() => window.location.href = "/dashboard"}
                                        tabIndex={0}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                window.location.href = "/dashboard";
                                            }
                                        }}
                                        aria-label="Más información"
                                    >
                                        Mas informaci&oacute;n <FaArrowAltCircleRight size={20} />
                                    </button>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>)}
                    
                </div>
            </section>
        </div>
    )
  }